/**
 * home27.js — PathPal Homepage 2027
 * Sticky mobile CTA · Ajax add-to-cart · GA4 event tracking
 * No jQuery. No GSAP. ~6kb minified.
 */

(function () {
  'use strict';

  /* ── Ajax Add-to-Cart ──────────────────────────────────────── */
  function addToCart(variantId, btn) {
    if (!variantId) {
      console.warn('[home27] No variant ID on button:', btn);
      return;
    }

    var originalText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span>Adding…</span>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (item) {
        // Fire GA4 add_to_cart event with beacon transport
        if (typeof gtag === 'function') {
          gtag('event', 'add_to_cart', {
            currency: 'USD',
            value: item.price / 100,
            items: [{
              item_id: item.variant_id,
              item_name: item.product_title,
              price: item.price / 100,
              quantity: 1
            }],
            transport_type: 'beacon'
          });
        }
        // Redirect to cart after beacon dispatch
        setTimeout(function () {
          window.location.href = '/cart';
        }, 180);
      })
      .catch(function (err) {
        console.error('[home27] Cart error:', err);
        btn.disabled = false;
        btn.innerHTML = originalText;
        // Show inline error (no alert)
        var errEl = btn.parentNode.querySelector('[data-h27-cart-error]');
        if (errEl) {
          errEl.textContent = 'Something went wrong. Please try again.';
          errEl.style.display = 'block';
        }
      });
  }

  /* ── CTA click delegation ─────────────────────────────────── */
  function initCartButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-h27-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.dataset.h27AddToCart;

      // GA4 CTA label tracking
      var label = btn.dataset.h27Label || 'Unknown CTA';
      if (typeof gtag === 'function') {
        gtag('event', 'cta_click', { cta_label: label });
      }

      addToCart(variantId, btn);
    });
  }

  /* ── Sticky Mobile CTA ────────────────────────────────────── */
  function initStickyCTA() {
    var hero = document.querySelector('[data-h27-hero]');
    var complete = document.querySelector('[data-h27-complete]');
    var sticky = document.querySelector('[data-h27-sticky]');

    if (!sticky || !hero) return;

    var pastHero = false;
    var inComplete = false;

    function updateVisibility() {
      var shouldShow = pastHero && !inComplete;
      sticky.classList.toggle('h27-sticky--visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    // Watch hero exit
    new IntersectionObserver(function (entries) {
      pastHero = !entries[0].isIntersecting;
      updateVisibility();
    }, { threshold: 0 }).observe(hero);

    // Watch complete system entry/exit
    if (complete) {
      new IntersectionObserver(function (entries) {
        inComplete = entries[0].isIntersecting;
        updateVisibility();
      }, { threshold: 0.1 }).observe(complete);
    }
  }

  /* ── Video lightbox (customer reviews) ───────────────────── */
  function initVideoLightbox() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-h27-video-open]');
      if (!trigger) return;
      var dialogId = trigger.dataset.h27VideoOpen;
      var dialog = document.getElementById(dialogId);
      if (dialog && dialog.showModal) {
        dialog.showModal();
        // Start video if present
        var video = dialog.querySelector('video');
        if (video) video.play();
      }
    });

    document.addEventListener('click', function (e) {
      var close = e.target.closest('[data-h27-video-close]');
      if (!close) return;
      var dialog = close.closest('dialog');
      if (dialog) {
        dialog.close();
        var video = dialog.querySelector('video');
        if (video) { video.pause(); video.currentTime = 0; }
      }
    });

    // Close on backdrop click
    document.querySelectorAll('[data-h27-video-dialog]').forEach(function (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) {
          dialog.close();
          var video = dialog.querySelector('video');
          if (video) { video.pause(); video.currentTime = 0; }
        }
      });
    });
  }

  /* ── Smooth scroll for anchor CTAs ───────────────────────── */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ── Hero video autoplay fallback ────────────────────────── */
  function initHeroVideo() {
    var video = document.querySelector('[data-h27-hero-video]');
    if (!video) return;
    var poster = document.querySelector('[data-h27-hero-poster]');

    function showPoster() {
      video.style.display = 'none';
      if (poster) poster.style.display = 'block';
    }

    function hidePoster() {
      video.style.display = 'block';
      if (poster) poster.style.display = 'none';
    }

    video.addEventListener('playing', hidePoster, { once: true });
    video.addEventListener('error', showPoster, { once: true });

    // Try to play; if blocked by autoplay policy, reveal the configured poster/fallback image.
    video.play().catch(showPoster);
  }

  /* ── Init ─────────────────────────────────────────────────── */
  function init() {
    initCartButtons();
    initStickyCTA();
    initVideoLightbox();
    initSmoothScroll();
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(initHeroVideo, { timeout: 600 });
    } else {
      setTimeout(initHeroVideo, 120);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
